import {useEffect, useState} from "react";
import {PatternFormat} from 'react-number-format';

import WINWorker from "../../Services/WINWorker";

export default function SalesContact(props) {

    const [isEditing, setIsEditing] = useState(false);
    const [memberRole, setMemberRole] = useState('');
    const [member, setMember] = useState({
        name: '',
        title: '',
        phone_number: '',
        email_address: ''
    });
    const [phone, setPhone] = useState('');
    const [isNew, setIsNew] = useState(false);
    const [updateMember, setUpdateMember] = useState([])
    const [memberList, setMemberList] = useState([])

    let updateMemberSelectOptions = [];
    let projectMembers = props.members;
    const company = window.company_id;

    let initMembers = () => {
        if (memberList.length === 0) {
            setMemberList(props.members);
        }
    }

    useEffect(
        () => {
            initMembers();
        },
        [props]
    );

    const editMember = (memberEdit) => {
        setIsEditing(false);
        setUpdateMember([]);
        setIsNew(false);
        setMember(memberEdit);
        setIsEditing(true);
    }

    const deleteMember = (memberEdit) => {
        setIsEditing(false);
        setIsNew(false);
        WINWorker.deleteCompanyEmployee(company, memberEdit)
            .then(response => {
                console.log('response', response);
                setMemberList(response);
                setMember({
                    name: '',
                    title: '',
                    phone_number: '',
                    email_address: ''
                });
            })
            .catch(error => {
                console.log('error', error);
            });
    }


    const addMember = () => {
        setIsEditing(true);
        setIsNew(true);
        setMemberRole('');
        setMember({
            name: '',
            title: '',
            phone_number: '',
            email_address: ''
        });
    }

    const createOrUpdateMember = () => {
        let createOrUpdateData = {};
        console.log('member:', member);
        if (!isNew) {
            console.log('updateMembesssr', member);
        } else {
            console.log('NEW', member);
        }
        setIsEditing(false);
        setIsNew(false);
        WINWorker.createOrUpdateCompanyEmployee(company, member)
            .then(response => {
                console.log('response', response);
                setMemberList(response);
                setMember({
                    name: '',
                    title: '',
                    phone_number: '',
                    email_address: ''
                });
            })
            .catch(error => {
                console.log('error', error);
            });
    }


    return (
        <div className="panel">
            <div className="panel__inner">
                <div className="panel__head">
                    <h5 className="panel__title">
                        {props.member_type_label}s
                    </h5>
                </div>
                <div className="panel__body">
                    <div className="flex-between">
                        <div className="flex__item flex__item-form-width">
                            {!isEditing &&
                                <a href="#" className="btn-item-add" onClick={(event) => {
                                    event.preventDefault();
                                    addMember();
                                }}>
                                    <span>Add {props.member_type_label}</span>
                                    <span className="btn__icon">
                        <img src="/static/images/png/plus-icon.png" alt="Icon Plus" width="58" height="58"/>
                    </span>
                                </a>
                            }
                            {isEditing && (
                                <React.Fragment>
                                    <form>
                                        <div className="form__row">
                                            <div className="form__group">
                                                <label className="form__label" htmlFor="name">Name:</label>
                                                <input type="text" name="name"
                                                       className="form-control form-control-name"
                                                       placeholder="Sales Contact Name" id="sales_contact_name"
                                                       value={member.name}
                                                       onChange={(e) => setMember((prevMember) => ({
                                                           ...prevMember,
                                                           name: e.target.value,
                                                       }))}/>
                                            </div>
                                        </div>
                                        <div className="form__row">
                                            <div className="form__group">
                                                <label className="form__label" htmlFor="sales_contact_title">Job
                                                    Title:</label>
                                                <input type="text" name="sales_contact_title"
                                                       className="form-control form-control-name"
                                                       placeholder="Sales Contact Job Title" id="sales_contact_title"
                                                       value={member.title}
                                                       onChange={(e) => setMember((prevMember) => ({
                                                           ...prevMember,
                                                           title: e.target.value,
                                                       }))}/>
                                            </div>
                                        </div>
                                        <div className="form__row">
                                            <div className="form__group">
                                                <label className="form__label" htmlFor="sales_contact_phone">Phone
                                                    Number:</label>
                                                <PatternFormat className="form-control form-control-name" format="###-###-####" allowEmptyFormatting mask="_" value={member.phone_number}
                                                               onValueChange={e => setMember((prevMember) => ({
                                                           ...prevMember,
                                                           phone_number: e.formattedValue,
                                                       }))}/>
                                            </div>
                                        </div>
                                        <div className="form__row">
                                            <div className="form__group">
                                                <label className="form__label" htmlFor="sales_contact_email">Email
                                                    Address:</label>
                                                <input type="text" name="sales_contact_email"
                                                       className="form-control form-control-name"
                                                       placeholder="Sales Contact Email Address"
                                                       id="sales_contact_email"
                                                       value={member.email_address}
                                                       onChange={(e) => setMember((prevMember) => ({
                                                           ...prevMember,
                                                           email_address: e.target.value,
                                                       }))}/>
                                            </div>
                                        </div>
                                        <div className="form__row form__row--flex involvement-submit">
                                            <button id="save-project-partner" type="submit" value="GO"
                                                    className="btn form__btnv save-project-partner"
                                                    onClick={(event) => {
                                                        event.preventDefault();
                                                        createOrUpdateMember();
                                                    }}>
                                                Done
                                            </button>
                                            <a href="#" className="link-icon cancel-project-partner"
                                               onClick={(event) => {
                                                   event.preventDefault();
                                                   setIsEditing(false);
                                               }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="10.68" height="13.732"
                                                     viewBox="0 0 10.68 13.732">
                                                    <path
                                                        d="M.763 12.206a1.53 1.53 0 0 0 1.526 1.526h6.1a1.53 1.53 0 0 0 1.526-1.526V3.051H.763zM2.64 6.774L3.715 5.7 5.34 7.317 6.957 5.7l1.076 1.076-1.617 1.617 1.617 1.617-1.076 1.076L5.34 9.467l-1.617 1.617-1.076-1.075 1.617-1.617zM8.01.763L7.247 0H3.433L2.67.763H0v1.526h10.68V.763z"
                                                        fill="currentColor"></path>
                                                </svg>
                                                <span>Cancel</span>
                                            </a>
                                        </div>
                                    </form>
                                </React.Fragment>
                            )}
                        </div>
                        <div className="flex__item company__save_contacts">
                            {memberList.map((item, index) => (
                                <div id={'member-' + item.id} key={index}
                                     className={`block-bordered-item management-list-item ${
                                         isEditing && member.id === item.id ? 'is-removable' : ''
                                     } `}>
                                    <div className="block__inner">
                                        <button className="user__remove member__delete" onClick={(event) => {
                                            event.preventDefault();
                                            deleteMember(item);
                                        }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="9.691" height="9.691"
                                                 viewBox="0 0 9.691 9.691">
                                                <g data-name="Group 730" fill="none" stroke="currentColor"
                                                   strokeMiterlimit="10">
                                                    <path data-name="Line 86" d="M.354.354l8.984 8.984"/>
                                                    <path data-name="Line 87" d="M9.338.354L.354 9.338"/>
                                                </g>
                                            </svg>
                                            Remove
                                        </button>
                                        <div className="block__content">
                                            <h6 className="block__title">
                                                {item.name}
                                            </h6>
                                            <div className="block__entry">
                                                <p>{item.title}</p>
                                            </div>
                                        </div>
                                        <div className="block__actions">
                                            {!isEditing && (
                                                <React.Fragment>
                                                    <a href="#" onClick={(event) => {
                                                        event.preventDefault();
                                                        editMember(item);
                                                    }} className="link-icon associate__cta">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="15.056"
                                                             height="15.058" viewBox="0 0 15.056 15.058">
                                                            <g fill="#707070">
                                                                <path data-name="Path 81"
                                                                      d="M11.135 4.392L8.782 2.04 2.509 8.313v2.353h2.353zm1.857-1.857a.625.625 0 0 0 0-.885L11.524.183a.625.625 0 0 0-.885 0l-1.23 1.23 2.353 2.353z"></path>
                                                                <path data-name="Path 82"
                                                                      d="M0 14.287h15.056v.77H0z"></path>
                                                            </g>
                                                        </svg>
                                                        <span>Edit</span>
                                                    </a>
                                                </React.Fragment>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
